/**
 * The kinds a context switch can be. A leaf on purpose: the type is derived
 * from the list so the runtime guard that reads persisted markers can never
 * lag a kind the compiler already knows about -- and it lives apart from
 * `config.ts` so a test that stubs the API client does not also stub the
 * vocabulary the transcript parser needs.
 */
export const CONTEXT_SWITCH_KINDS = [
  'none',
  'artifact',
  'artifact_gallery',
  'workflow_canvas',
  'workflow_node',
  'skill_doc',
  'node_chat',
] as const;

export type ContextSwitchKind = (typeof CONTEXT_SWITCH_KINDS)[number];
